import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col, Row } from 'antd';

import Styles from './ButtonUserInformation.module.scss';
import { TButtonUserInformation } from './definitions';
import ButtonProfile from '../../Atoms/ButtonProfile';
import ButtonUnAuth from '../../Atoms/ButtonUnAuth';

const ButtonUserInformation: React.FC<TButtonUserInformation> = ({
  dataAuth,
}) => {
  return (
    <Col className={Styles['col-btn-user-information']}>
      <Row justify="end" align="middle" className={Styles['session-info']}>
        {dataAuth?.isLogged ? (
          <ButtonProfile dataAuth={dataAuth} />
        ) : (
          <ButtonUnAuth />
        )}
      </Row>
    </Col>
  );
};

export default ButtonUserInformation;
